export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SET_REMEMBER_ME = "SET_REMEMBER_ME";
export const CLEAR_REMEMBER_ME = "CLEAR_REMEMBER_ME";
export const SET_APP_SETTING = "SET_APP_SETTING";
export const SET_EVENTS = "SET_EVENTS";
export const SET_PAST_EVENTS = "SET_PAST_EVENTS";
